export default "/images/db4007bd0d4d7f57e92693ebf1698e87.avif";